export const STRATEGIST = {
  name: "LaRaine Weatherspoon",
  title: "Lane Strategist Consultant",
  business: "RouteHaul High Desert Logistics Partners",
  email: "RouteHaulhd@routehaulhdlp.com",
  ctaLabel: "Book a Lane Strategy Session",
  blurb:
    "I'm LaRaine Weatherspoon, a lane strategist who helps freight owner-operators pick profitable lanes, price loads above their break-even, and stop chasing cheap freight — so your miles actually make money.",
  short: "Lane strategy for owner-operators who want profitable miles, not just busy ones.",
};

export const mailtoLink = () => {
  const subject = encodeURIComponent("Lane Strategy Session request");
  const body = encodeURIComponent(
    `Hi LaRaine,\n\nI'd like to talk about my lanes and rates.\n\nName:\nPhone:\nEquipment / lanes I run:\n\nThanks!`
  );
  return `mailto:${STRATEGIST.email}?subject=${subject}&body=${body}`;
};
